<template>
    <v-flex class="investments" v-if="companyInvestments.length > 0 || isCurrentUser">
        <v-flex tag="h2">{{memberProfileConstants.COMPANY_INVESTMENTS}}<v-flex tag="em" data-qe-id="companyInvestments_seeAll" v-if="seeAllInvestments" @click="seeAll()">{{isEnabled}}</v-flex>
            <i class="fas fa-pencil-alt ml-2" data-qe-id="opencompanyInvestments_dialog" v-if="companyInvestments.length > 0 && isCurrentUser" @click="openCompanyInvestmentsDialog()"></i>
            <i class="fas fa-pencil-alt ml-2" data-qe-id="opencompany_dialog" v-if="!companyInvestments.length > 0 && isCurrentUser" @click="openCompanyDialog()"></i>
        </v-flex>
        <v-flex>
            <v-flex v-if="!companyInvestments.length > 0 && isCurrentUser"> {{memberProfileConstants.DEFAULT_EDIT_TEXT.COMPANY_INVESTMENTS}} </v-flex>
            <status-overlay :action="loadGetCompanyInvestmentsAction" content-height="200px">
            </status-overlay>
        </v-flex>
        <v-layout row wrap v-if="!expanded">
            <v-flex xs12 sm4 v-for="(companyInvestment,index) in companyInvestments.slice(0,3)" :key="index">
                <v-flex class="investments__row" >
                    <v-flex tag="strong" v-if="companyInvestment.url">
                        <a data-qe-id="companyInvestments_title" :href="normalizeUrl(companyInvestment.url)" target="_blank">
                            {{companyInvestment.name}}
                        </a>
                    </v-flex>
                    <v-flex class="tag" v-if="!companyInvestment.url">
                        {{companyInvestment.name}}
                    </v-flex>
                    <v-flex tag="span">{{companyInvestment.industryCategory}}</v-flex>
                    <v-flex tag="span">{{companyInvestment.subIndustryCategory}}</v-flex>
                </v-flex>
            </v-flex>
        </v-layout>
        <v-layout row wrap v-if="expanded">
            <v-flex xs12 sm4  v-for="(row, idx1) in investmentsMatrix" :key="idx1">
                <v-flex class="investments__row" v-for="(col, idx2) in row" :key="idx2">
                    <v-flex tag="strong" v-if="investmentsMatrix[idx1][idx2].url">
                        <a data-qe-id="companyInvestments_title" :href="normalizeUrl(investmentsMatrix[idx1][idx2].url)" target="_blank">
                            {{investmentsMatrix[idx1][idx2] ? investmentsMatrix[idx1][idx2].name : null}}
                        </a>
                    </v-flex>
                    <v-flex class="tag" v-if="!investmentsMatrix[idx1][idx2].url">
                        {{investmentsMatrix[idx1][idx2] ? investmentsMatrix[idx1][idx2].name : null}}
                    </v-flex>
                    <v-flex tag="span">{{investmentsMatrix[idx1][idx2] ? investmentsMatrix[idx1][idx2].industryCategory: null}}</v-flex>
                    <v-flex tag="span">{{investmentsMatrix[idx1][idx2] ? investmentsMatrix[idx1][idx2].subIndustryCategory: null}}</v-flex>
                </v-flex>
            </v-flex>
        </v-layout>
        <v-dialog scrollable v-model="companyInvestmentDialog" content-class="medium">
            <v-card class="myprofile-popup">
                <v-card-title primary-title>
                    {{memberProfileConstants.COMPANY_INVESTMENT.EDIT_COMPANY_INVESTMENT}}
                    <i class="fas fa-times" data-qe-id="edit_company-investment" @click="companyInvestmentDialog = false"></i>
                </v-card-title>
                <v-card-text class="inner-scrollbar" ref="companyViewDialog">
                    <v-flex v-for="(companyInvestment,index) in companyInvestments" :key="index" class="details-view">
                        <v-flex tag="h6" ml-3>
                            {{companyInvestment.name}}
                            <i class="fas fa-pencil-alt" data-qe-id="edit_company-investment_name" @click="editCompanyInvestment(companyInvestment)"></i>
                        </v-flex>
                        <v-flex tag="small">{{companyInvestment.industryCategory}}</v-flex>
                        <v-flex tag="small">{{companyInvestment.subIndustryCategory}}</v-flex>
                    </v-flex>
                    <v-flex class="btn-row">
                        <v-btn class="primary_btn" data-qe-id="open-company_add-more_btn" @click="openCompanyDialog()">
                            <i class="fas fa-plus-circle mr-2"></i>{{memberProfileConstants.ADD_MORE}}
                        </v-btn>
                    </v-flex>
                </v-card-text>
                <v-card-actions>
                    <v-flex text-xs-right pa-3>
                        <v-btn class="primary_btn" data-qe-id="close-company_add-more_btn" @click="closeCompanyInvestmentView()">
                            {{appCommonConstants.CLOSE}}
                        </v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog scrollable v-model="companyInvestmentEditDialog" content-class="medium">
            <v-card class="myprofile-popup" id="companyInvestments" v-if="companyInvestmentEditDialog">
                <v-card-title primary-title>
                    {{memberProfileConstants.COMPANY_INVESTMENT.EDIT_COMPANY_INVESTMENT}}
                    <i class="fas fa-times" data-qe-id="cancel_dialog_btn" @click="cancel()"></i>
                </v-card-title>
                <v-card-text class="inner-scrollbar" ref="companyDialogId">
                    <v-flex v-for="(company, index) in companyInvestmentsDetails" :key="index" class="investments-details">
                        <v-form :id="index" lazy-validation :ref="`company-${company.id}`" v-model="valid">
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.NAME}} {{memberProfileConstants.ASTERISK}}</span>
                                        <v-flex class="autocomplete" v-on:mouseleave="isSearchOpen=false">
                                            <v-text-field
                                                required 
                                                :maxlength="memberProfileConstants.MAX_NAME_COUNT_EIGHTY"
                                                :placeholder="memberProfileConstants.TYPE_TO_SEARCH" 
                                                v-model="company.name"
                                                data-qe-id="company-search_input_field"
                                                color="ypo_blue"
                                                @input="getSearchResults(company)"
                                                @keydown.down="onArrowDown"
                                                @keydown.up="onArrowUp"
                                                @keydown.enter="onEnter(company.name)">
                                            </v-text-field>
                                            <v-list v-if="isSearchVisible(company.name) && company.isSearch" id="autocomplete-results" v-show="isSearchOpen" class="autocomplete-results">
                                                <v-list-tile
                                                    class="autocomplete-result"
                                                    v-for="(result, i) in results"
                                                    :key="i"
                                                    :data-qe-id="`company-search_result-${i}`"
                                                    @click="setResult(result, company)"
                                                    :class="{ 'is-active': i === arrowCounter }">
                                                    <v-list-tile-title v-highlight = "{keyword: company.name, sensitive: false}">
                                                    {{ result }}
                                                    </v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </v-flex>
                                    </v-flex>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.WEBSITE}}</span>
                                        <span class="select-required">{{memberProfileConstants.REQUIRED}}</span>
                                        <v-text-field
                                                :placeholder="memberProfileConstants.WEBSITE"
                                                v-model="company.url"
                                                data-qe-id="company-investment_input_field"
                                                color="ypo_blue"
                                                :rules="memberProfileConstants.WEBSITE_URL_RULE"
                                                @input="editCompany(company)">
                                        </v-text-field>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.LOCATION}}</span>
                                        <v-flex>
                                            <v-text-field 
                                                :placeholder="memberProfileConstants.LOCATION"
                                                v-model="company.location"
                                                data-qe-id="company-location_input_field"
                                                color="ypo_blue"
                                                @input="editCompany(company)">
                                            </v-text-field>
                                        </v-flex>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.INDUSTRY}}</span>
                                        <v-autocomplete
                                            attach
                                            height="40"
                                            data-qe-id="company-industry_select"
                                            v-model="company.industryCategory"
                                            :items="Object.keys(industry).sort()"
                                            :placeholder="memberProfileConstants.INDUSTRY" 
                                            color="ypo_blue"
                                            v-on:input="editCompany(company)">
                                        </v-autocomplete>
                                    </v-flex>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">   
                                        <span class="select-label">{{memberProfileConstants.SUB_INDUSTRY}}</span>
                                        <v-autocomplete
                                            attach
                                            height="40"
                                            data-qe-id="company-sub-industry_select"
                                            v-model="company.subIndustryCategory"
                                            :items="company.subIndustry"
                                            :placeholder="memberProfileConstants.SUB_INDUSTRY" 
                                            color="ypo_blue"
                                            :no-data-text="noSubIndustry(company.subIndustry, company.industryCategory)"
                                            v-on:input="editCompany(company)">
                                        </v-autocomplete>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.TOPIC}}</span>
                                        <v-text-field color="ypo_blue" 
                                            :placeholder="memberProfileConstants.TOPIC"
                                            data-qe-id="company-topic_input-field"
                                            v-model="company.topic"
                                            :maxlength="memberProfileConstants.MAX_NAME_LENGTH"
                                            @input="editCompany(company)">
                                        </v-text-field>
                                        <span class="select-label">{{memberProfileConstants.DESCRIPTION}}</span>
                                            <v-text-field class="text-number" color="ypo_blue"
                                                :counter="255"
                                                data-qe-id="company-description_input-field"
                                                :placeholder="memberProfileConstants.DESCRIPTION"
                                                v-model="company.description"
                                                @input="editCompany(company)"
                                                :maxlength="memberProfileConstants.MAX_LENGTH">
                                            </v-text-field>
                                    </v-flex>
                                </v-flex>
                                <v-flex class="btn-row mt-3">
                                    <v-btn class="primary_btn" 
                                        v-if="!company.isEditDialog" 
                                        :disabled="!company.isAdd"
                                        data-qe-id="company_add-more_btn"
                                        @click="addCompany(company)">
                                        <i class="fas fa-plus-circle mr-2"></i> {{memberProfileConstants.ADD_MORE}}
                                    </v-btn>
                                    <v-btn small class="primary_btn" 
                                        @click ="deleteCompany(company.id, index)"
                                        data-qe-id="company_delete_btn"
                                        :disabled="company.isDelete">
                                        <i class="fas fa-trash-alt mr-2"></i>{{appCommonConstants.DELETE}}
                                    </v-btn>
                                    <v-flex class="save-to-profile" v-model="company.isSuccess" v-if="company.isSuccess">
                                        <i class="fas fa-check"></i> <span>{{memberProfileConstants.SAVED_TO_PROFILE}}</span>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                            <v-dialog v-model="deleteInformationDialog" lazy absolute content-class="post-actions">
                                <v-card>
                                    <v-flex tag="h6">{{memberProfileConstants.DIALOG_CONFIRMATION_TITLE}}
                                        <v-btn icon data-qe-id="delete-confirmation_btn" @click="deleteInformationDialog=false">
                                            <v-icon size="20">close</v-icon>
                                        </v-btn>
                                    </v-flex>
                                    <v-flex tag="p">
                                        {{memberProfileConstants.DIALOG_CONFIRMATION_DESC}}
                                    </v-flex>
                                    <v-flex text-xs-right>
                                        <status-bar :action="deleteCompanyAction"></status-bar>
                                        <v-btn flat data-qe-id="cancel_dialog_btn"
                                            @click="deleteInformationDialog = false" class="primary_btn transparent">
                                            {{memberProfileConstants.CANCEL}}
                                        </v-btn>
                                        <v-btn dark data-qe-id="continue_dialog_btn"
                                            @click="deleteInformation()" class="primary_btn">
                                            {{memberProfileConstants.CONTINUE}}
                                        </v-btn>
                                    </v-flex>
                                </v-card>
                            </v-dialog>
                        </v-form>
                    </v-flex>
                </v-card-text>
                <status-bar :action="editCompanyAction"></status-bar>
                <status-bar :action="saveCompanyAction"></status-bar>
                <v-card-actions>
                    <v-flex text-xs-right pa-3>
                        <v-flex>
                            <v-btn class="primary_btn transparent" data-qe-id="cancel_save_btn" @click="cancel()">
                                {{appCommonConstants.CANCEL}}
                            </v-btn>
                            <v-btn class="primary_btn" :disabled="!valid || isSave" data-qe-id="confirm_save_btn"
                                @click="saveCompanyInvestments()">
                                {{appCommonConstants.DONE}}
                            </v-btn>
                        </v-flex>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-flex>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { storeAction } from "../../store/storeActions.constant";
import { storeGetters } from "../../store/storeGetters.constant";
import { memberProfileConstants, noSubIndustry, filterResults } from "./memberProfile.constants.js";
import { appCommonConstants } from "../appCommon.constants.js";
import { normalizeUrl } from '@/common/utils/utils';
import StatusBar from "../StatusBar/StatusBar";
import { uuid } from 'vue-uuid';
import Vue from 'vue';
import StatusOverlay from '../StatusOverlay/StatusOverlay';
import { gaDataLayerEvent } from "@/plugins/analytics";
import { gtmEventName } from "@/plugins/gtmAnalytics";

export default {
    name: "CompanyInvestments",
    data: () => ({
        memberProfileConstants,
        appCommonConstants,
        noSubIndustry,
        filterResults,
        expanded: false,
        investmentsMatrix: [],
        companyInvestmentDialog: false,
        companyInvestmentEditDialog: false,
        deleteInformationDialog: false,
        companyInvestmentsDetails: [],
        results: [],
        isSearchOpen: false,
        isSearchLoading: false,
        arrowCounter: 0,
        isSave: true,
        isOpenEditDialog: false,
        companyId: null,
        index: null,
        valid: false,
        uuid: uuid.v1(),
        normalizeUrl,
        postBody: {
            type: null,
            name: null,
        },
        company: {
            id: null,
            name: '',
            url: null,
            industryCategory: null,
            subIndustryCategory: null,
            topic: '',
            description: null,
            location: null,
            type: memberProfileConstants.COMPANY_INVESTMENT.TYPE,
            isEdit: false,
            isDelete: true,
            isAdd: false,
            isEditDialog: false,
            isSuccess: false,
            issearch: false,
            subIndustry: [],
        },
    }),
    components: {
        StatusBar,
        StatusOverlay,
    },
    props: {
        memberId: {
            type: String,
            required: true,
        },
    },
    created() {
      if(this.memberId)
        this.getCompanyInvestments(this.memberId);
    },
    methods: {
        ...mapActions({
            getCompanyInvestments: `memberProfile/${storeAction.getCompanyInvestments}`,
            searchExternalConnection: `memberProfile/${storeAction.searchExternalConnection}`,
            updateCompanyInvestment: `memberProfile/${storeAction.updateCompanyInvestment}`,
            saveCompanyInvestment: `memberProfile/${storeAction.saveCompanyInvestment}`,
            deleteCompanyInvestment: `memberProfile/${storeAction.deleteCompanyInvestment}`,
        }),
        seeAll() {
            this.expanded = !this.expanded;
        },
        openCompanyInvestmentsDialog() {
            this.companyInvestmentDialog = true;
        },
        editCompany(company) {
            company.isEdit = true;
            company.subIndustry = this.industry[company.industryCategory];
            if (company.name && company.name.length <= this.memberProfileConstants.MAX_NAME_LENGTH) {
                this.isSave = false;
                company.isAdd = true;
            } else {
                this.isSave = true;
                company.isAdd = false;
            }
        },
        generateGUID() {
            return uuid.v1();
        },
        openCompanyDialog() {
            this.isOpenEditDialog = false;
            this.companyInvestmentsDetails = [];
            this.companyInvestmentsDetails.push(Vue.util.extend({}, this.company));
            this.companyInvestmentEditDialog = true;
            this.isSave = true;
        },
        closeCompanyInvestmentView() {
            this.$refs.companyViewDialog.scrollTop = 0;
            this.companyInvestmentDialog = false;
        },
        editCompanyInvestment(company) {
            this.companyInvestmentsDetails = [{
                id: company.id,
                name: company.name,
                url: company.url,
                industryCategory: company.industryCategory,
                subIndustryCategory: company.subIndustryCategory,
                topic: company.topic,
                description: company.description,
                location: company.location,
                type: company.type,
                isEditDialog: true,
                subIndustry: this.industry[company.industryCategory],
            }];
            this.isSave = false;
            this.companyInvestmentEditDialog = true;
            this.isOpenEditDialog = true;
            this.companyId = company.Id;
        },
        addCompany(company) {
            const [ref] = this.$refs[`company-null`];
            if (ref && ref.validate()) {
                this.isOpenEditDialog = false;
                company.isEditDialog = false;
                company.id = this.generateGUID();
                company.personId = this.memberId;
                company.isEdit = false;
                const postBody = [{
                    ...company,
                }];
                this.saveCompanyInvestment(postBody)
                .then(() => {
                    ref.resetValidation();
                    company.isDelete = false;
                    company.isAdd = true;
                    company.isSuccess = true;
                    company.isSearch = false;
                    company.isEditDialog = true;
                    const index = this.companyInvestmentsDetails.length;               
                    //takes a bit for dom to actually update
                    setTimeout(() => {
                        document.getElementById(index).scrollIntoView();
                    }, 100);
                    this.companyInvestmentsDetails.push(Vue.util.extend({}, this.company));
                    gaDataLayerEvent(gtmEventName.C_Profile_Edit, `Investments - ${this.memberId}${this.isRedirectFromConnectPlus ? ' | Connect+ Redirect' : ''}`);
                });
            }
        },
        saveCompanyInvestments() {
            if (this.isOpenEditDialog) {
                const [ref] = this.$refs[`company-${this.companyInvestmentsDetails[0].id}`];
                if (ref && ref.validate()) {
                    const postBody = { 
                        ...this.companyInvestmentsDetails[0],
                    };
                    postBody.personId = this.memberId;
                    this.updateCompanyInvestment(postBody)
                    .then(() => {
                        ref.resetValidation();
                        this.companyInvestmentEditDialog = false;
                        this.scrollTop();
                        gaDataLayerEvent(gtmEventName.C_Profile_Edit, `Investments - ${this.memberId}${this.isRedirectFromConnectPlus ? ' | Connect+ Redirect' : ''}`);
                    });
                }
            } else {
                const postbody = this.companyInvestmentsDetails.filter(x => x.isEdit === true);
                if (postbody.length === 0) {
                    this.validationAddMore();
                    return false;
                }
                const idExists = postbody.some((el) => {
                    return el.id === null;
                });
                if (!idExists) {
                    this.saveCompanyInvestmentsAPI(postbody);
                } else {
                    postbody.forEach((x) => {
                        if (x.id === null) {
                            x.id = this.generateGUID();
                        }
                        x.personId = this.memberId;
                    });
                    const [ref] = this.$refs[`company-null`];
                    if (ref.validate()) {
                        this.saveCompanyInvestmentsAPI(postbody);
                    }
                }
            }
        },
        saveCompanyInvestmentsAPI(postbody) {
            this.saveCompanyInvestment(postbody)
            .then(() => {
                this.validationAddMore();
                gaDataLayerEvent(gtmEventName.C_Profile_Edit, `Investments - ${this.memberId}${this.isRedirectFromConnectPlus ? ' | Connect+ Redirect' : ''}`);
            });
        },
        deleteCompany(companyId, index) {
            this.deleteInformationDialog = true;
            this.companyId = companyId;
            this.index = index;
        },
        deleteInformation() {
            const parms = {
                companyId: this.companyId,
                personId: this.memberId,
            };
            this.deleteCompanyInvestment(parms)
            .then(() => {
                this.deleteInformationDialog = false;
                if (this.index <= 0 && this.companyInvestmentsDetails.length === 1) {
                    this.companyInvestmentEditDialog = false;
                    if (this.companyInvestments.length === 0) {
                        this.companyInvestmentDialog = false;
                    }
                } else {
                    Vue.delete(this.companyInvestmentsDetails, this.index);
                }
                this.scrollTop();
            });
        },
        cancel() {
            this.resetValidation();
            this.isSave = true;
            this.companyInvestmentEditDialog = false;
            this.scrollTop();
          if(this.memberId)
              this.getCompanyInvestments(this.memberId)
            .then(() => {
                this.companyInvestmentDialog = this.companyInvestments.length !== 0;
            });
        },
        resetValidation() {
            this.companyInvestmentsDetails.forEach((x) => {
                const [ref] = this.$refs[`company-${x.id}`];
                if (ref && ref.resetValidation) {
                    ref.resetValidation();
                }
            });
        },
        getSearchResults(company) {
            company.isEdit = true;
            company.isSearch = true;
            if (company.name && company.name.length <= this.memberProfileConstants.MAX_NAME_LENGTH) {
                this.isSave = false;
                company.isAdd = true;
            } else {
                this.isSave = true;
                company.isAdd = false;
            }
            if (company.name.length >= memberProfileConstants.THREE) {
                this.postBody.type = 'Company Investment';
                this.postBody.name = company.name;
                this.isSearchLoading = true;
                this.searchExternalConnection(this.postBody)
                .then(() => {
                    this.results = this.filterResults(this.companySearchResult, company.name);
                    this.isSearchOpen = true;
                    this.isSearchLoading = false;
                });
            }
        },
        setResult(result, company) {
            company.name = result;
            this.isSearchOpen = false;
        },
        onArrowDown() {
            if (this.arrowCounter < this.results.length) {
                this.arrowCounter = this.arrowCounter + 1;
            }
        },
        onArrowUp() {
            if (this.arrowCounter > 0) {
                this.arrowCounter = this.arrowCounter - 1;
            }
        },
        onEnter(company) {
            company.name = this.results[this.arrowCounter];
            this.isSearchOpen = false;
            this.arrowCounter = -1;
        },
        isSearchVisible(companyName) {
            if (companyName !== undefined && companyName !== null) {
                return companyName.length >= this.memberProfileConstants.THREE && this.results.length;
            }
            return false;
        },
        scrollTop() {
            if (this.$refs.companyDialogId) {
                this.$refs.companyDialogId.scrollTop = 0;
            }
        },
        validationAddMore() {
            this.companyInvestmentEditDialog = false;
            this.companyInvestmentDialog = this.companyInvestments.length !== 0;
            this.scrollTop();
        },
    },
    computed: {
        ...mapState("actionState", ["actions"]),
        ...mapGetters({
            companyInvestments: `memberProfile/${storeGetters.companyInvestments}`,
            companySearchResult: `memberProfile/${storeGetters.courseAndCertificateSearchResult}`,
            currentUserId: `memberProfile/${storeGetters.currentUserId}`,
            industry: `memberProfile/${storeGetters.externalConnectionIndustry}`,
            chapterAdminEditable: `memberProfile/${storeGetters.chapterAdmin}`,
        }),
        seeAllInvestments() {
            return this.companyInvestments.length > this.memberProfileConstants.INVESTMENTS_MIN_COUNT;
        },
        isCurrentUser() {
            return this.memberId === this.currentUserId || this.chapterAdminEditable;
        },
        saveCompanyAction() {
            return this.actions[storeAction.saveCompanyInvestment];
        },
        editCompanyAction() {
            return this.actions[storeAction.updateCompanyInvestment];
        },
        deleteCompanyAction() {
            return this.actions[storeAction.deleteCompanyInvestment];
        },
        isEnabled() {
            return this.expanded ?
                memberProfileConstants.SEE_LESS :
                memberProfileConstants.SEE_ALL;
        },
        loadGetCompanyInvestmentsAction() {
            return this.actions[storeAction.getCompanyInvestments];
        },
        isRedirectFromConnectPlus() {
          return this.$route && this.$route.query
              && this.$route.query.connectPlusRedirect && this.$route.query.connectPlusRedirect === 'true';
        },
    },
    watch: {
        companyInvestments(val) {
            this.investmentsMatrix = [];
            if (val.length > 0) {
                const companyInvestmentslength = val.length;
                if (companyInvestmentslength > this.memberProfileConstants.INVESTMENTS_MIN_COUNT) {
                    const colLimit = this.memberProfileConstants.COLUMN_LIMIT;
                    this.investmentsMatrix = new Array(colLimit);
                    for (let i = 0; i < this.investmentsMatrix.length; i += 1) {
                        this.investmentsMatrix[i] = [];
                    }
                    const rowLimit = (companyInvestmentslength % colLimit) === 0 ? Math.floor(companyInvestmentslength / colLimit) : Math.floor(companyInvestmentslength / colLimit) + 1;
                    this.companyInvestments.forEach((ci, i) => {
                        const colNum = Math.floor(i / rowLimit);
                        const rowNum = i % rowLimit;
                        this.investmentsMatrix[colNum][rowNum] = ci;
                    });
                }
            }
            if (val.length <= 3) {
                this.expanded = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../common/styles/_colors.scss';

.investments {
    position: relative;
    margin-bottom: -9px;
    padding-bottom: 20px;
    padding: 0 20px 20px 20px;
    &__row {
        margin-bottom: 30px;

        .tag {
            display: block;
            font-size: 14px;
            margin-bottom: 5px;
            color: $black;
            font-weight: 500;
        }
        
        strong {
            display: block;
            font-size: 14px;
            margin-bottom: 5px;
            color: $ypo-cta;
            font-weight: 500;
        }

        span {
            color: $ypo-gray-text;
            font-size: 12px;
            line-height: 18px;
            display: block;
        }

        a {
            color: $ypo-cta;
            text-decoration: none;
        }
    }

    &-details {
        border-bottom: 2px solid $ypo-gray;
        margin-bottom: 20px;

        &:last-child {
            border-bottom: none;
            margin-bottom: 0;
        }
    }
    @media (max-width: 1199px){
            padding: 0 0 20px 0;
        }
    .overlay {
        top: 35px;
    }
}

h2 {
    color: $ypo_blue;
    font-family: "Raleway", sans-serif;
    font-size: 22px;
    font-weight: 500;
    margin-bottom: 20px;
    line-height: 26px;

    em {
        color: $ypo-cta;
        font-family: "Noto Sans", sans-serif;
        font-size: 14px;
        line-height: 24px;
        font-style: normal;
        margin-left: 10px;
        cursor: pointer;
    }
}

.v-card {
    .select-required {
        color: $ypo-blue;
        font-size: 14px;
        font-weight: bold;
        line-height: 20px;
        margin-left: 228px;
        @media (max-width: 767px) {
            display: none;
        }
    }
}
</style>
